import {
  CommentOutlined,
  DeleteOutlined,
  EditFilled,
  EyeOutlined,
  FileDoneOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { ReactComponent as ChevronDown } from "@src/styles/icon/chevron-down.svg";
import { ReactComponent as ChevronUp } from "@src/styles/icon/chevron-up.svg";
import { Avatar, Button, Collapse, List, Modal, Tooltip } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ApiDisaster } from "../../../api/backend/disaster";
import {
  COMMON_CONSTANT,
  DISASTER_CONVERSATION_TYPE,
  DISASTER_STATUS,
  KEY,
  lang,
} from "../../../constants/common.const";
import { handleCatchError, showMessage } from "../../../constants/utils";
import { getIconByFileType } from "../../../utils/helper";
import "./../disaster.scss";
const ListFeedback = ({
  listFeedBack = [],
  setShowLoading,
  getDetailDisaster,
  onEditFeedBack,
  status
}) => {
  const { id } = useParams();
  const { Panel } = Collapse;
  const { userName } = useSelector((state) => state.auth);

  // Get Text Type
  const getTextTypeDisaster = (type) => {
    let text, color, Icon;
    if (type == DISASTER_CONVERSATION_TYPE.CONFIRM_DAMAGED) {
      text = lang.DAMAGED;
      color = "#EF4444";
      Icon = MinusCircleOutlined;
    }
    if (type == DISASTER_CONVERSATION_TYPE.COMPLETE_PROCEDURES) {
      text = COMMON_CONSTANT.CONFRIM_COMPLETE_PROCEDURES;
      color = "#0080CB";
      Icon = FileDoneOutlined;
    }
    if (type == DISASTER_CONVERSATION_TYPE.FOLLOWING) {
      text = COMMON_CONSTANT.CONFRIM_FOLLOWING;
      color = "#DAA520";
      Icon = EyeOutlined;
    }
    if (type == DISASTER_CONVERSATION_TYPE.CONFIRM_NO_DAMAGED) {
      text = lang.NO_DAMAGED;
      color = "#2FAD5A";
      Icon = CheckCircleOutlined;
    }
    if (type == DISASTER_CONVERSATION_TYPE.CONFIRM_WAITING) {
      text = lang.WAITING;
      color = "#DDA0DD";
      Icon = ClockCircleOutlined;
    }
    if (type == DISASTER_CONVERSATION_TYPE.CLOSE) {
      text = lang.FINISH;
      color = "#0080CB";
      Icon = CloseCircleOutlined;
    }
    if (text) {
      return (
        <p
          className="description-feedback"
          style={{
            color,
          }}
        >
          <Icon />
          <span style={{ marginTop: 2 }}>{text}</span>
        </p>
      );
    }
    return null;
  };

  const showAction = (type) => {
    return (
      type != DISASTER_CONVERSATION_TYPE.CLOSE
    );
  };

  // render List File
  const renderListFile = (list) =>
    list.map((file, index) => (
      <div className="mb5 flex-center" key={index}>
        {getIconByFileType(file.attachFileName)}
        <a
          target="_blank"
          style={{
            fontWeight: "normal",
            fontSize: 14,
            marginTop: 3,
          }}
          href={file.attachFileUrl}
        >
          {file.attachFileName}
        </a>
      </div>
    ));

  function ContentFeedBack({ item }) {
    const handleDeleteFeedBack = () => {
      // Action del
      const funcDel = async () => {
        setShowLoading(true);

        // API Del
        try {
          // Close warning
          Modal.destroyAll();

          await ApiDisaster.deleteFeedBack(id, item.id);
          // API Search
          await getDetailDisaster();

          // Open success
          showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
        } catch (ex) {
          handleCatchError(ex);
        } finally {
          setShowLoading();
        }
      };

      Modal.confirm({
        icon: <QuestionCircleOutlined />,
        centered: true,
        title: lang.DELETE,
        content: COMMON_CONSTANT.BOM_C001,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: funcDel,
      });
    };
    return (
      <div className="feedback-item">
        <p
          style={{
            fontSize: 12,
          }}
        >
          {item.time}
        </p>
        {getTextTypeDisaster(item.type)}
        <p
          style={{
            color: "black",
          }}
        >
          {item.note}
        </p>
        <div>{renderListFile(item.attachments)}</div>
        {item.username === userName && showAction(item.type) && status != DISASTER_STATUS.CLOSE &&   (
          <div className="feedback-action">
            <Tooltip title={lang.EDIT}>
              <Button
                onClick={() => onEditFeedBack(item.type, item)}
                className="mr5 btn"
              >
                <EditFilled className="" />
              </Button>
            </Tooltip>

            {/* Delete */}
            <Tooltip title={lang.DELETE}>
              <Button
                onClick={() => handleDeleteFeedBack()}
                className="mr5 btn"
              >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </div>
        )}
      </div>
    );
  }

  return (
    <Collapse
      defaultActiveKey={"1"}
      style={{
        width: "100%",
      }}
      className="tabMachine"
      expandIcon={({ isActive }) =>
        isActive ? <ChevronDown /> : <ChevronUp />
      }
      expandIconPosition="right"
    >
      <Panel
        key={"1"}
        header={
          <div className="bold">
            <CommentOutlined
              style={{ color: "#0080cb", marginRight: 10, fontSize: 20 }}
            />
            {lang.FEED_BACK}
          </div>
        }
      >
        <List
          itemLayout="horizontal"
          dataSource={listFeedBack}
          renderItem={(item, index) => {
            const title = (
              <div className="cursor-pointer">
                <span className="link-name bold">{item.displayName}</span>
              </div>
            );
            return (
              <List.Item
                style={{
                  padding: 10,
                }}
                key={index}
              >
                <List.Item.Meta
                  style={{
                    position: "relative",
                  }}
                  avatar={
                    <Avatar
                      src={item.avatarUrl}
                      size={40}
                      style={{
                        backgroundColor: "#fde3cf",
                        color: "#f56a00",
                      }}
                    >
                      {!item.avatarUrl &&
                        item.displayName &&
                        typeof item.displayName === "string" &&
                        item.displayName[0].toUpperCase()}
                    </Avatar>
                  }
                  title={title}
                  description={<ContentFeedBack item={item} />}
                  className="mb0"
                />
              </List.Item>
            );
          }}
        />
      </Panel>
      {/* </div> */}
    </Collapse>
  );
};
export default ListFeedback;
